import React from 'react';
import useTranslate from '~/hooks/useTranslate';
import { RouteComponentProps, useHistory, withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '~/store/types/sharedTypes';
import Button, { ButtonType } from '~/components/shared/Button/button';
import Logo from '~/components/shared/LogoOld/LogoOld';
import PageHeader from '~/components/shared/PageHeader/PageHeader';
import PageTitle from '~/components/shared/PageTitle/PageTitle';
import {
  BodyContainer,
  MainContainer,
  PageFooter,
} from '~/styles/BaseStyledComponents';
import withGtmEvent from '~/components/hoc/withGtmEvent';
import { compose } from 'redux';
import TerminatedContractCard from './components/TerminatedContractCard';

const TerminatedContract: React.FC<RouteComponentProps<any>> = (props) => {
  const loanId = props.match.params.loans;
  const history = useHistory();
  const t = useTranslate();

  const terminatedContractData = useSelector(
    (state: RootState) => state.loans.terminatedContract
  );

  const onBackButtonClick = () => {
    history.push(`/`);
  };

  const correctTerminatedContract = terminatedContractData.find(
    (contract) => contract.contractId === Number(loanId)
  );

  return (
    <MainContainer>
      <PageHeader hideAllMenus>
        <Logo mt={2} mb={4} />
        <PageTitle mb={4}>{t('TerminatedContract') as string}</PageTitle>
      </PageHeader>
      <BodyContainer>
        {correctTerminatedContract && (
          <TerminatedContractCard
            terminatedContract={correctTerminatedContract}
          />
        )}
      </BodyContainer>
      <PageFooter>
        <Button type={ButtonType.Filled} onClick={onBackButtonClick}>
          {t('BackButton')}
        </Button>
      </PageFooter>
    </MainContainer>
  );
};

export default compose(withGtmEvent, withRouter)(TerminatedContract);
